var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack119({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.14 0.83 12.5 4.31 9.17 6.88 11.08 8.21 8.1 10.6 9.82 11.69 4.23 15.17 5.95 12.02 3.5 10.12 6.63 7.9 4.28 5.45 7.14 0.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack119);
export default __webpack_public_path__ + "static/media/Symbolpack_1_19.098308cc938f4e208db50b348ad22721.svg";
export { ForwardRef as ReactComponent };